import config from '@/common/config';
import { getTokenPrice } from '@/features/account-abstraction/constants/abis';
import { useMemo } from 'react';
import { formatUnits } from 'viem/utils';
import { useReadContract } from 'wagmi';

const usePhnmPrice = () => {
  console.log('usePhnmPrice hook called');
  console.log('Config:', config);

  const { data, isLoading, isError } = useReadContract({
    address: config.contracts.redemptionVault,
    functionName: 'getTokenPrice',
    chainId: config.chain?.id,
    abi: getTokenPrice,
  });

  console.log('useReadContract result:', { data, isLoading, isError });

  const displayPrice = useMemo(() => {
    console.log('Calculating displayPrice, raw data:', data);
    if (!data) return '-';

    const numberString = formatUnits(data, config.usdtDecimals);
    console.log('Formatted number string:', numberString);

    const [integerPart, decimalPart] = numberString.split('.');
    console.log('Split parts:', { integerPart, decimalPart });

    let truncated;
    if (decimalPart) {
      truncated = `${integerPart}.${decimalPart.slice(0, 2)}`;
    } else {
      truncated = integerPart;
    }
    console.log('Truncated result:', truncated);

    return truncated;
  }, [data]);

  console.log('Final hook result:', { data: { value: data, displayPrice }, isLoading, isError });

  return { data: { value: data, displayPrice }, isLoading, isError };
};

export default usePhnmPrice;
